export const production = true;

export const environment = {
  production,
  APP_ID: 'careapp-web-beta',
  APP_VERSION: '1.0.0',
  API_V2_BASE_PATH: 'https://api.careapp.com.au',
  API_BASE_URL: 'https://api.careapp.com.au',
  APP_BASE_URL: 'https://beta.careapp.com.au/#',
  kratosFrontendUrl: 'https://accounts.careapp.com.au',
  API_VERSION: 'api/v1',
  GOOGLE_MAPS_API_KEY: 'AIzaSyBWvmTl7YRL30d-qrmKMuEPSbXssz6RHU8',
  ROLLBAR_ACCESS_TOKEN: '76c70f6830b546878a9576567872d0aa',
  ROLLBAR_ENV_NAME: 'BETA',
  STATS_TABLE_LIMIT: 5,
  httpTimeout: 10000,
  chatPollInterval: 30000,
  notificationsPollInterval: 60000,
  streamApiKey: '3xab2y6mqyh4',
  useKratos: true,

  maxVideoUploadLengthS: 300,

  fileDownloadMode: 'get',

  announcements: {
    shareToFamilyRepresentatives: true,
  },
  documents: {
    shareToFamilyRepresentatives: true,
  },
  questions: {
    shareToFamilyRepresentatives: true,
  },

  stripe: {
    publicKey:
      'pk_live_51NaV3oKYjY3VzQOjAmIvQaBT2tosC3mu87dVwarvxyVSL7JCZEolc1xpWQk6bTtY6uRqtVRtbYOxsoSv6RutZxuf00Thj5jEVE',
  },

  /**
   * TTL for cached objects in the store, in milliseconds
   */
  cacheTime: 1 * 60 * 60 * 1000,

  memoriam: {
    resourcesBaseUrl:
      'https://careapp-video-transcoding-memoriamresourcesbucket-8hgpcgh3tz7r.s3-website-ap-southeast-2.amazonaws.com',
  },

  releaseNotes: {
    feedUrl: 'https://www.careapp.com.au/category/release-notes/feed/',
  },

  firebase: {
    apiKey: 'AIzaSyBwDIVadU5AdoJ35f2fumi0gW2OEN6GJIA',
    authDomain: 'careapp-32941.firebaseapp.com',
    databaseURL: 'https://careapp-32941.firebaseio.com',
    projectId: 'careapp-32941',
    storageBucket: 'careapp-32941.appspot.com',
    messagingSenderId: '136981136015',
    appId: '1:136981136015:web:2fe5295386f516eb2ba6fa',
    measurementId: 'G-8XS80FX38T',
    remoteConfig: {
      memoriam_music_options: [],
      show_config_list: false,
      web_configure_2fa: true,
      preferred_countries: [],
      web_phone_based_password_reset: false,
      web_provider_customer_management: false,
      web_set_email: false,
      web_family_representative: true,
      web_member_management: false,
      web_provider_notice_management: false,
      web_integrations: true,
      web_member_badges: false,
      web_wrapped_enabled: false,
      wrapped_year: '2024',
      web_sensitive_memos: true,
    },
  },
};
